// src/router.js
import { createWebHistory, createRouter } from 'vue-router'
import store from '@/store'
//import { WSService } from '@/services/ws.service'

const routes =  [
    { path: '/', alias: '/main', name: 'main', component: () => import('./components/Main'), meta: { auth: true }, },
    { path: '/login', name: 'login', component: () => import('./components/Login'), },
    { path: '/statistics', name: 'statistics', component: () => import('./components/statistics/Statistics'), meta: { auth: true }, },
    {
        path: '/dashboard', name: 'dashboard', redirect: { name: 'dashboard-main' },
        component: () => import('./components/Dashboard'),
        meta: { auth: true, title: 'Дашборд', icon: 'tachometer-alt', menu: true, permission: 'dashboardView' },
        children: [
            { path: 'main', name: 'dashboard-main', component: () => import('./components/dashboard/Main'), meta: { auth: true, title: 'Главная статистика', menu: true, permission: 'dashboardView' } },
            { path: 'report', name: 'dashboard-report', component: () => import('./components/dashboard/Report'), meta: { auth: true, title: 'Отчет о заказах', menu: true, permission: 'dashboardView' } },
        ]
    },
    {
        path: '/shop', name: 'shop', redirect: { name: 'shop-orders' },
        component: () => import('./components/orders/Shop'),
        meta: { auth: true, title: 'Магазин', icon: 'shopping-cart', menu: true, permission: 'ordersView' },
        children: [
            { path: 'orders/:page(\\d+)?', name: 'shop-orders', component: () => import('./components/orders/Orders'), meta: { auth: true, title: 'Заказы', menu: true, permission: 'ordersView' } },
            { path: 'orders/:id', name: 'shop-order', component: () => import('./components/orders/Order'), meta: { auth: true, permission: 'ordersView' } },
            { path: 'orders/add', name: 'shop-order-add', component: () => import('./components/orders/OrderAdd'), meta: { auth: true, permission: 'ordersManage' } },
            { path: 'orders/edit/:id', name: 'shop-order-edit', component: () => import('./components/orders/OrderEdit'), meta: { auth: true, permission: 'ordersEdit' } },
        ]
    },
    {
        path: '/staff', name: 'staff', redirect: { name: 'staff-users' },
        component: () => import('./components/users/Staff'),
        meta: { auth: true, title: 'Сотрудники', icon: 'users', menu: true, permission: 'staffUsersView' },
        children: [
            { path: 'users', name: 'staff-users', component: () => import('./components/users/Users'), meta: { auth: true, title: 'Пользователи', menu: true, permission: 'staffUsersView' } },
            { path: 'users/:id', name: 'staff-user', component: () => import('./components/users/User'), meta: { auth: true, permission: 'staffUsersView' } },
            { path: 'users/add', name: 'staff-user-add', component: () => import('./components/users/UserAdd'), meta: { auth: true, permission: 'staffUsersManage' } },
            { path: 'users/edit/:id', name: 'staff-user-edit', component: () => import('./components/users/UserEdit'), meta: { auth: true, permission: 'staffUsersEdit' } },
            { path: 'groups', name: 'staff-groups', component: () => import('./components/groups/Groups'), meta: { auth: true, title: 'Группы', menu: true, permission: 'staffGroupsView' } },
            { path: 'groups/:id', name: 'staff-group', component: () => import('./components/groups/Group'), meta: { auth: true, permission: 'staffGroupsView' } },
            { path: 'groups/add', name: 'staff-group-add', component: () => import('./components/groups/GroupAdd'), meta: { auth: true, permission: 'staffGroupsManage' } },
            { path: 'groups/edit/:id', name: 'staff-group-edit', component: () => import('./components/groups/GroupEdit'), meta: { auth: true, permission: 'staffGroupsEdit' } },
        ]
    },
    {
        path: '/change',
        name: 'change',
        redirect: { name: 'change-queue' },
        component: () => import('./components/change/Change'),
        meta: { auth: true, title: 'Обмен', icon: 'repeat', menu: true, permission: 'changeQueueView', /*parentMenu: true*/ },
        children: [
            { path: 'queue', name: 'change-queue', component: () => import('./components/change/ChangeQueue'), meta: { auth: true, title: 'Очередь', menu: true, permission: 'changeQueueView' } },
            { path: 'items/:page(\\d+)?', name: 'change-items', component: () => import('./components/change/ChangeItems'), meta: { auth: true, title: 'Товары', menu: true, permission: 'changeItemsView' } },
            //{ path: 'items', name: 'change-items', component: () => import('./components/change/ChangeItems'), meta: { auth: true, title: 'Товары', menu: true, permission: 'changeItemsView' } },
            { path: 'marketplaces', name: 'change-marketplaces', component: () => import('./components/change/ChangeMarketplaces'), meta: { auth: true, title: 'Маркетплейсы', menu: true, permission: 'changeMarketplacesView' } },
            { path: 'settings', name: 'change-settings', component: () => import('./components/change/ChangeSettings'), meta: { auth: true, title: 'Настройки', menu: true, permission: 'changeSettingsView' } },
            { path: 'item/:id', name: 'change-item', component: () => import('./components/change/ChangeItem'), meta: { auth: true, permission: 'changeItemsView' } },
        ]
    },
    { path: '/machines', name: 'machines', component: () => import('./components/Machines'), meta: { auth: true, title: 'Станки', icon: 'industry', permission: 'factorySetView' } },
    // Без permission: в настройках лежит смена своего пароля — она нужна каждому сотруднику
    { path: '/settings', name: 'settings', component: () => import('./components/Settings'), meta: { auth: true, title: 'Настройки', icon: 'cogs', menu: true } },
    { path: '/access-denied', name: 'access-denied', component: () => import('./components/AccessDenied') }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

// После деплоя у открытой вкладки остаётся старая сборка: файл страницы (chunk) со старым хэшем
// уже не существует, переход молча не происходил («страница не открывается»).
// Ловим ошибку загрузки chunk'а и один раз полностью перезагружаем страницу на нужный адрес.
router.onError((error, to) => {
    const msg = String(error?.message || error)
    const isChunkError = error?.name === 'ChunkLoadError' || /Loading (CSS )?chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(msg)
    if (!isChunkError) return
    const target = to?.fullPath || window.location.pathname
    const key = 'nxChunkReload'
    let last = null
    try { last = sessionStorage.getItem(key) } catch (e) { /* приватный режим */ }
    if (last === target) return // уже перезагружали ради этого адреса — не уходим в цикл
    try { sessionStorage.setItem(key, target) } catch (e) { /* приватный режим */ }
    window.location.assign(target)
})

router.afterEach(() => {
    try { sessionStorage.removeItem('nxChunkReload') } catch (e) { /* приватный режим */ }
})

router.beforeEach((to) => {
    const user = store.getters.currentUser

    if (to.meta.auth && !user) {
        return { path: '/login', query: { redirect: to.fullPath } }
    }

    if (user && to.meta.permission && !store.getters.hasPermission(to.meta.permission)) {
        return { name: 'access-denied' }
    }
})

export default router